import api from './api';

const outsourceService = {
  getWorklist: async (params = {}) => {
    const res = await api.get('/outsource/worklist', { params });
    return res.data;
  },

  getSummary: async () => {
    const res = await api.get('/outsource/summary');
    return res.data;
  },

  getById: async (outsourceId) => {
    const res = await api.get(`/outsource/${outsourceId}`);
    return res.data;
  },

  getByTestId: async (testId) => {
    const res = await api.get(`/outsource/test/${testId}`);
    return res.data;
  },

  createDispatchBatch: async (data) => {
    const res = await api.post('/outsource/dispatch-batch', data);
    return res.data;
  },

  getBatchManifest: async (batchId) => {
    const res = await api.get(`/outsource/dispatch-batch/${batchId}`);
    return res.data;
  },

  recordResult: async (data) => {
    const res = await api.post('/outsource/record-result', data);
    return res.data;
  },

  verifyResult: async (data) => {
    const res = await api.post('/outsource/verify', data);
    return res.data;
  }
};

export default outsourceService;
